var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBi = function SvgIconBi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.307 2.48a12.006 12.006 0 0 0-14.614 0L12 9.787zM12 14.214l-7.307 7.307a12.006 12.006 0 0 0 14.614 0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6DA544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.787 12 2.48 4.694a12.006 12.006 0 0 0 0 14.613zM14.215 12l7.306 7.307a12.006 12.006 0 0 0 0-14.613z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 17.218a5.217 5.217 0 1 0 0-10.435 5.217 5.217 0 0 0 0 10.435"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 8.348.452.783h.903l-.451.782.451.783h-.903l-.452.783-.452-.783h-.903l.451-.783-.451-.782h.903zM9.703 12.001l.452.783h.904l-.452.782.452.783h-.904l-.452.782-.452-.782h-.903l.451-.783-.451-.782h.903zM14.297 12.001l.452.783h.903l-.451.782.451.783h-.903l-.452.782-.452-.782h-.904l.452-.783-.452-.782h.904z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconBi;